module.exports = __webpack_public_path__ + "static/media/OB1 Saudi Headshot.137d27bc.jpg";